<template>
  <CCard>
    <CCardHeader>
      <h2>休日出勤報告詳細</h2>
    </CCardHeader>
    <CCardBody>
      <CRow>
        <div class="container">
          <CAlert v-if="errorMessage" color="danger">{{ errorMessage }}</CAlert>
          <table class="table">
            <tr><th scope="row">更新日</th><td class="preika-report-detail-date">{{ updated_at }}</td></tr>
            <tr><th scope="row">日付</th><td class="preika-report-detail-date"><span>{{ formatDate(holiday_work_date) }}</span></td></tr>
            <tr><th scope="row">開始予定時間</th><td class="preika-report-detail-time"><span>{{ start_time }}</span></td></tr>
            <tr><th scope="row">終了予定時間</th><td class="preika-report-detail-time"><span>{{ end_time }}</span></td></tr>
            <tr><th scope="row">発生理由</th><td class="preika-report-detail-reason"><span>{{ reason }}</span></td></tr>
          </table>
          <CRow class="mt-3 align-items-center">
            <CCol class="text-start">
              <router-link :to="{ name: holidayWorksList }">
                <button class="btn btn-secondary">戻る</button>
              </router-link>
            </CCol>
            <CCol class="text-center">
              <router-link :to="{ name: holidayWorksEdit, params: { id: $route.params.id } }">
                <button class="btn btn-info">編集</button>
              </router-link>
            </CCol>
            <CCol></CCol>
          </CRow>
        </div>
      </CRow>
    </CCardBody>
  </CCard>
</template>

<script>
import axios from 'axios'
import ConstList from './../../ConstList'
import { safeErrorDigest } from '../../utils/safeResponseMessage'

export default {
  name: 'Info',
  data () {
    return {
      holiday_work_date: '',
      start_time: '',
      end_time: '',
      reason: '',
      updated_at: '',
      errorMessage: '',
      holidayWorksList: ConstList.ROUTE_HOLIDAYWORKS_LIST,
      holidayWorksEdit: ConstList.ROUTE_HOLIDAYWORKS_EDIT
    }
  },
  methods: {
    formatDate (dateStr) {
      if (!dateStr) return ''
      const [yyyy, mm, dd] = dateStr.split('-')
      return `${yyyy}/${mm}/${dd}`
    }
  },
  mounted () {
    const id = Number(this.$route.params.id)
    if (!Number.isSafeInteger(id) || id <= 0) {
      this.errorMessage = '休日出勤報告を特定できませんでした。一覧から選択し直してください。'
      return
    }
    axios
      .get(`${process.env.VUE_APP_API_ORIGIN}/holidayWork/${id}`)
      .then(response => {
        if (!response.data) {
          this.errorMessage = ConstList.RECORD_NOT_FOUND
          return
        }
        const holidayWorkData = response.data
        this.holiday_work_date = holidayWorkData.date
        this.start_time = holidayWorkData.start_time
          ? holidayWorkData.start_time.substring(0, 5)
          : ''
        this.end_time = holidayWorkData.end_time
          ? holidayWorkData.end_time.substring(0, 5)
          : ''
        this.reason = holidayWorkData.reason
        this.updated_at = holidayWorkData.updated_at
      })
      .catch(error => {
        this.errorMessage = '休日出勤報告を取得できませんでした。画面を再読み込みしてください。'
        console.error('休日出勤報告詳細取得失敗:', safeErrorDigest(error))
      })
  }
}
</script>

<style scoped>
button:disabled {
  cursor: not-allowed;
}
.container {
  margin-left: 0%;
}
</style>
